import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";

type State = {
  IdMedicaoTerceirizacao: number;
  FornecedorPesquisa: number;
  ContratoPesquisa: number;
  StatusPesquisa: number;
  FornecedorAvaliadoPesquisa: number;
  NotaFiscalPesquisa: number;
  centroDeCusto: number[];
  centroDeCustoLista: CentroCustoDropDown[] | undefined;
  NMedicaoPesquisa: string;
};

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setFornecedorPesquisa: SetFunction<number>;
  setContratoPesquisa: SetFunction<number>;
  setStatusPesquisa: SetFunction<number>;
  setFornecedorAvaliadoPesquisa: SetFunction<number>;
  setNotaFiscalPesquisa: SetFunction<number>;
  setCentroDeCusto: SetFunction<number[]>;
  setCentroDeCustoLista: SetFunction<CentroCustoDropDown[]>;
  setNMedicaoPesquisa: SetFunction<string>;
};

export const initialFiltersValues: State = {
  IdMedicaoTerceirizacao: 0,
  FornecedorPesquisa: 0,
  ContratoPesquisa: 0,
  NMedicaoPesquisa: "",
  StatusPesquisa: 5,
  FornecedorAvaliadoPesquisa: 2,
  centroDeCusto: [],
  centroDeCustoLista: undefined,
  NotaFiscalPesquisa: 2,
};

export const useMedicaoFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setFornecedorAvaliadoPesquisa: (vfn) => SetFunctionImpl(set, 'FornecedorAvaliadoPesquisa', vfn),
  setNMedicaoPesquisa: (vfn) => SetFunctionImpl(set, 'NMedicaoPesquisa', vfn),
  setContratoPesquisa: (vfn) => SetFunctionImpl(set, 'ContratoPesquisa', vfn),
  setFornecedorPesquisa: (vfn) => SetFunctionImpl(set, 'FornecedorPesquisa', vfn),
  setStatusPesquisa: (vfn) => SetFunctionImpl(set, 'StatusPesquisa', vfn),
  setNotaFiscalPesquisa: (vfn) => SetFunctionImpl(set, 'NotaFiscalPesquisa', vfn),
  setCentroDeCusto: (vfn) => SetFunctionImpl(set, 'centroDeCusto', vfn),
  setCentroDeCustoLista: (vfn) => SetFunctionImpl(set, 'centroDeCustoLista', vfn),

  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
    centroDeCustoLista: state.centroDeCustoLista
  })),
}));